export default "__VITE_ASSET__e262be63__"